import { SystemStyleObject } from '@aloft/toolkit-sui/chakra';

export function getRowStyles(
  isActive: boolean,
  isHovered: boolean,
  isSelected: boolean,
  enableHoverStyle: boolean,
  customBackgroundColor?: string,
): SystemStyleObject {
  let backgroundColor: string | undefined = undefined;
  if (customBackgroundColor) {
    backgroundColor = customBackgroundColor;
  } else if (isSelected) {
    backgroundColor = 'surface2';
  }
  if (isActive) backgroundColor = 'selected4';
  if (!isActive && isHovered) backgroundColor = 'hover1';

  return {
    td: {
      backgroundColor,
    },
    _hover: {
      td: {
        backgroundColor: isActive || !enableHoverStyle ? undefined : 'hover1',
      },
    },
  };
}
